import axios from 'axios';
import { API_URL } from '.';

export type ContactValues = {
    name: string;
    email: string;
    details: string;
}

export const sendContact = async (contact: ContactValues) => {
    await axios.post(`${API_URL}/contacts`, contact);
}
